module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/127-sri-lanka-5a49544a953c838396e72827ef1eab56.svg";